import React from 'react';
import { useEffect, useRef } from "react";

import Business from "../assets/image/business.png";
import Industry from "../assets/image/insdustries.png";
import Entrepreneur from "../assets/image/connected.png";
import Employee from "../assets/image/employee.png";

export default function Stats() {
   const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-show");
          }
        });
      },
      { threshold: 0.3 }
    );

    cardRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const stats = [
    {
      icon: Business,
      number: "800,000+",
      label: "Businesses Served"
    },
    {
      icon: Industry,
      number: "196+",
      label: "Industries Catered"
    },
    {
      icon: Entrepreneur,
      number: "50M+",
      label: "Entrepreneurs Connected"
    },
    {
      icon: Employee,
      number: "200+",
      label: "Employees & Growing"
    }
  ];

  return (
    <>
    <style>{`.card-base {
          transition: opacity 0.4s ease-out;
        }

        .animate-show {
  animation: floatIn 0.2s ease-out both;
  opacity: 1;
}


        @keyframes floatIn {
          0% {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          100% {
            opacity: 1;
            transform: translateY(0px) scale(1);
          }
        }
      `}</style>
        <section id='about' className=" bg-white pt-[20px] sm:pt-[20px] md:pt-[0px] lg:pt-[0px] pb-[40px] sm:pr-[20px] sm:pl-[20px] md:pr-[18px] md:pl-[20px]">

    <div className="  flex items-center justify-center pr-6 pl-6 pb-6 ">
      <div className="w-full max-w-[1280px] h-fit sm:max-w-[1280px]  lg:max-w-[1280px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-11">
          {stats.map((stat, index) => (
          <div
            key={index}
            ref={(el) => (cardRefs.current[index] = el)}
            className="card-base opacity-0 border-[0.5px] border-[#00000033] rounded-tl-[60px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] "
            style={{ animationDelay: `${index * 0.1}s` }}
          >
          
            <div
              key={index}
              className=" rounded-tl-[60px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] border-[6px] border-[#0000000D]  shadow-xl  flex flex-col leading-[28px] w-fit items-center text-center md:items-start
              pl-0 gap-8 min-w-[230px] min-h-[238px]
              pl-0 pb-4
              sm:pl-0 sm:pb-4 
              md:pl-4 md:pb-4
              lg:pl-6 lg:pb-6"
              
                 >
                <div className="
                  flex items-center 
                  justify-center 
                  pt-4 pr-[76px] pl-[76px]
                  sm:pt-4 sm:pr-[130px] sm:pl-[130px]
                  md:pt-4 md:pr-[186px] md:pl-[0px]
                  
                  xl:pt-4 xl:pr-[110px] xl:pl-[0px]

                
                ">
                <img
                  src={stat.icon}
                  alt={stat.label}
                  className="w-full h-full object-contain"
                />
              </div>
              <div
             
              className="flex flex-col leading-[28px] w-fit items-center text-center md:items-start
              "
                 >
              <h3 className=" font-inter text-[28.89px] sm:text-[28.89px] md:text-[33.89px] text-black font-semibold  mb-2">
                {stat.number}
              </h3>

              <p className=" font-inter text-[#404040] text-[16px] font-normal  ">
                {stat.label}
              </p>
              </div>
            </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </section>
    </>
  );
}